// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MouthClosed = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.177 12.748a.5.5 0 0 0-1 0c0 1.716-1.425 3.112-3.177 3.112s-3.177-1.396-3.177-3.112a.5.5 0 0 0-1 0c0 2.267 1.874 4.112 4.177 4.112 2.303 0 4.177-1.845 4.177-4.112ZM14.564 7.64c-.423 0-.765.524-.765 1.17 0 .646.342 1.17.765 1.17.422 0 .765-.524.765-1.17 0-.646-.343-1.17-.765-1.17Zm-5.137 0c-.423 0-.766.524-.766 1.17 0 .646.343 1.17.766 1.17s.765-.524.765-1.17c0-.646-.342-1.17-.765-1.17ZM12 21.875c-5.445 0-9.875-4.43-9.875-9.875S6.555 2.125 12 2.125s9.875 4.43 9.875 9.875-4.43 9.875-9.875 9.875Z"
			fill="#fff"
		/>
	</svg>
);
export default MouthClosed;
